import React, { lazy, Suspense } from "react";
import PropTypes from "prop-types";
import clsx from "clsx";
import makeStyles from "@material-ui/styles/makeStyles";

const ReactSVGIcon = lazy(() =>
	import(/* webpackChunkName: "reactSVGIcon" */ "@micado-digital/react-svg-icon/ReactSVGIcon")
);
const ReactLink = lazy(() =>
	import(/* webpackChunkName: "reactLink" */ "@micado-digital/react-link/ReactLink")
);

const useStyles = makeStyles(theme => ({
	link: {
		color: "inherit",
		display: "inline-flex",
		transition: theme.transitions.create(["color"], {
			duration: theme.transitions.duration.standard
		}),
		"&:hover, &:focus": {
			color: theme?.palette?.secondary?.main
		},
		[theme.breakpoints.down("md")]: {
			display: "block",
			overflow: "hidden",
			textOverflow: "ellipsis",
			whiteSpace: "nowrap"
		}
	},
	linkLevel1: {
		color: theme?.palette?.secondary?.light,
		borderTop: "1px solid #364E61",
		padding: theme.spacing(1, 0),
		...theme?.customTypography?.footer02?.footermenu?.mobile?.level1,
		[theme.breakpoints.up("md")]: {
			borderTop: "none",
			marginBottom: theme?.spacing(3),
			padding: theme.spacing(0)
		},
		[theme.breakpoints.up("lg")]: {
			borderTop: "none",
			...theme?.customTypography?.footer02?.footermenu?.desktop?.level1
		}
	},
	linkLevel2: {
		color: "#FFFFFF",
		...theme?.customTypography?.footer02?.footermenu?.mobile?.level2,
		[theme.breakpoints.up("md")]: {
			fontSize: 14
		},
		[theme.breakpoints.up("lg")]: {
			fontSize: 14,
			marginBottom: theme?.spacing(0.5)
		},
		[theme.breakpoints.up("xl")]: {
			...theme?.customTypography?.footer02?.footermenu?.desktop?.level2
		}
	},
	icon: {
		marginRight: theme?.spacing(2)
	}
}));

const FootermenuItem = ({ icon, level, link, selected, target, title }) => {
	const css = useStyles();
	const hasHref = link && link !== "#";

	return (
		<Suspense fallback={<></>}>
			<ReactLink
				className={clsx("mco-footer-02__footermenu-item", css.link, {
					[css.linkSelected + " mco-footer-02__footermenu-item--selected"]: selected,
					[css.linkLevel1 + " mco-footer-02__footermenu-item--level1"]: level === 1,
					[css.linkLevel2 + " mco-footer-02__footermenu-item--level2"]: level === 2
				})}
				to={hasHref ? link : "#"}
				target={target ? target : null}
			>
				{icon && (
					<Suspense fallback={<></>}>
						<ReactSVGIcon
							className={clsx("mco-footer-02__footermenu-icon", css.icon)}
							src={icon}
						></ReactSVGIcon>
					</Suspense>
				)}
				<span dangerouslySetInnerHTML={{ __html: title }} />
			</ReactLink>
		</Suspense>
	);
};

FootermenuItem.propTypes = {
	icon: PropTypes.string,
	level: PropTypes.number,
	link: PropTypes.string.isRequired,
	selected: PropTypes.bool,
	target: PropTypes.string,
	title: PropTypes.string.isRequired
};

export default FootermenuItem;
